import { KYMW1409Component } from './kymw1409.component';

/**
 * マーク指示画面の値を管理するクラス
 *
 * @export KYMW1409Model
 * @class KYMW1409Model
 */
export class KYMW1409Model {

  kymw1409Component: KYMW1409Component;

  // 検索結果
  /**
   * 検索結果格納用 Array<any>
   */
  public markInfoList: Array<any> = null;
  private _markInfoListDisp: Array<any> = null;

  /**
   * マークグループコンボボックス
   */
  public markGroupList: Array<any> = null;

  /**
   * Ｐコードコンボボックス
   */
  public pCodeList: Array<any> = null;

  /**
   * マークグループ別マーク使用一覧
   */
  public selectedMarkList: Array<any> = null;

  /**
   * 商品名
   */
  public lblGuideGoodsName: string = null;

  /**
   * 規格名
   */
  public lblGuideStandardName: string = null;

  /**
   * マーク
   */
  public imgMarkFileURL: string = null;

  /**
   * 受注コード
   */
  public orderCode: string = null;

  /**
   * 生協コード
   */
  public coopCode: string = null;

  /**
   * 注文商品区分
   */
  public orderGoodsFlg: string = null;

  // データ保持用
  /**
   * Ｐコードコンボボックス
   */
  public cmbPCodeList: Array<any> = new Array<any>();
  // Ｐコードコンボボックス選択値
  pCode = String('');

  /**
   * マークグループコンボボックス
   */
  public cmbMarkGroupList: Array<any> = new Array<any>();

  // マークグループコンボボックス選択値
  markGroup = String('');

  // 同一マークコードで使用マークコード登録APIを連続実行すると
  // サーバー側でPKの一意制約違反が発生しサーバーエラーとなるので回避するために変数を用意
  // リプレース開発にて表のセルクリックでチェックボックスを操作できるようにしたが
  // その影響で現象が発生するようになったと思われる
  // 画面のイベントハンドラ側で多重クリックを防ごうと試みたが上手くいかなかったのでこの方法とした
  public blockDuplicateMarkCode = null;

  /**
   * 画面活性可モード
   */
  public enabledMode = String('');

  public disabledGoodsFlagALL = Boolean(true);

  public goodsFlagALL = Boolean(false);

  get markInfoListDisp(): Array<any> {
    return this._markInfoListDisp;
  }

  set markInfoListDisp(list: Array<any>) {
    this.markInfoList.forEach(e => {
      e['RowIdx'] = undefined;
    });
    this._markInfoListDisp = list;
    this._markInfoListDisp.forEach((e, idx) => {
      e['RowIdx'] = idx;
    });
  }

  /**
   * マークグループコンボボックス作成
   *
   * @param {*} serverData サーバ取得データ
   * @memberof KYMW1409Model
   */
  public setMarkGroupList(serverData: any): void {
    if (serverData == null) {
      this.cmbMarkGroupList = new Array<any>();
    } else {
      this.cmbMarkGroupList = serverData.MarkGroupInfo.Record;
    }

    const showArray: Array<any> = new Array<any>();

    // 先頭の空白行を設定
    showArray.push({ lbl: '', code: '' });
    // マークグループ名
    for (let index = Number(0); index < this.cmbMarkGroupList.length; index++) {
      showArray.push({ lbl: this.cmbMarkGroupList[index].MarkGroupName, code: this.cmbMarkGroupList[index].MarkGroupCode });
    }

    this.markGroupList = showArray;
  }

  /**
   * 使用マーク設定
   *
   * @memberof KYMW1409Model
   */
  public setMark(): void {
    // マーク指示の出力項目を設定
    this.kymw1409Component.updateDataGridViewColumn();
  }

  /**
   * Orderタグを分離してserverXMLにタグを追加する
   *
   * @private
   * @param {*} obj
   * @param {Array<any>} order
   * @returns {Array<any>}
   * @memberof KYMW1409Model
   */
  private getOrderList(obj: any, order: Array<any>): Array<any> {
    const orderList: Array<any> = order;

    // 使用マークのデータを作成
    for (let i = Number(0); i < orderList.length; i++) {
      obj[orderList[i].PCode] = orderList[i].SelectedStatus === '1';
    }
    return obj;
  }

  /**
   * サーバ取得データを反映する
   *
   * @param {*} serverData サーバ取得データ
   * @memberof KYMW1409Model
   */
  public updateServerResponse(serverData: any): void {
    // 作業用変数定義
    let markListArray: Array<any> = new Array<any>();
    const markList: Array<any> = new Array<any>();
    const goodsList: Array<any> = new Array<any>();

    // 検索結果の格納を行う
    if (serverData != null) {

      markListArray = serverData.MarkList.Record;

      for (let i = Number(0); i < markListArray.length; i++) {
        let obj: any = new Object();
        obj = this.getOrderList(obj, serverData.MarkList.Record[i].Selection);
        obj.MarkGroupCode = serverData.MarkList.Record[i].MarkGroupCode;
        obj.Duplication = serverData.MarkList.Record[i].Duplication;
        obj.MarkCode = serverData.MarkList.Record[i].MarkCode;
        obj.MarkName = serverData.MarkList.Record[i].MarkName;
        obj.img_MarkFileName = serverData.MarkList.Record[i].MarkFileName;
        obj.Enabled = this.enabledMode;
        // 作業用配列に追加
        markList.push(obj);
      }

      // 注文商品区分(orderGoodsFlg)によってデータ格納先(GoodsInfo, GoodsInfo2, GoodsInfo3)は変わらないことになった
      if (serverData.GoodsInfo != null && typeof serverData.GoodsInfo.Record !== 'undefined') {
        for (let j = Number(0); j < serverData.GoodsInfo.Record.length; j++) {
          const obj: any = new Object();
          obj.PCode = serverData.GoodsInfo.Record[j].PCode;
          obj.GuideGoodsName = serverData.GoodsInfo.Record[j].GuideGoodsName;
          obj.GuideStandardName = serverData.GoodsInfo.Record[j].GuideStandardName;

          // 作業用配列に追加
          goodsList.push(obj);
        }
      }
    }

    // マーク指示の出力項目を設定
    this.kymw1409Component.updateDataGridViewColumn();

    // 作業用配列を現在の配列に書き換え
    for (const e of this.pCodeList) {
      for (const ee of goodsList) {
        if (e.PCode === ee.PCode) {
          e.GuideGoodsName = ee.GuideGoodsName;
          e.GuideStandardName = ee.GuideStandardName;
          break;
        }
      }
    }
    this.markInfoList = markList;
    this.markInfoListDisp = markList;

    this.resetBlockDuplicateMarkCodeList();

    // 選択マーク一覧作成
    this.kymw1409Component.changePCodeComboBox();
  }

  public resetBlockDuplicateMarkCodeList() {
    this.blockDuplicateMarkCode = Object();
    for (const pCode of this.pCodeList) {
      this.blockDuplicateMarkCode[pCode.PCode] = [];
    }

    for (const markInfo of this.markInfoListDisp) {
      for (const pCode of this.pCodeList) {
        if (markInfo[pCode.PCode] === true) {
          this.blockDuplicateMarkCode[pCode.PCode].push(markInfo.MarkCode)
        }
      }
    }
  }
}
